import { Helmet } from 'react-helmet-async';

import { CONFIG } from 'src/config-global';
import { DashboardContent } from 'src/layouts/dashboard';
import { ProgramMembers } from 'src/sections/home/program-members';

// ----------------------------------------------------------------------

const metadata = { title: `Program Members |  ${CONFIG.appName}` };

export default function Page() {
  return (
    <>
      <Helmet>
        <title> {metadata.title}</title>
      </Helmet>
      <DashboardContent>
        <ProgramMembers />
      </DashboardContent>
    </>
  );
}
